module.exports = __webpack_public_path__ + "static/media/listEmgea.a694f002.png";